module.exports = __webpack_public_path__ + "static/media/glyphicons-halflings-regular.fa277232.woff";


//////////////////
// WEBPACK FOOTER
// ./~/bootswatch/fonts/glyphicons-halflings-regular.woff
// module id = 1104
// module chunks = 0